import { render, staticRenderFns } from "./ProfileDataImage.vue?vue&type=template&id=2d3e69ed&scoped=true&"
import script from "./ProfileDataImage.vue?vue&type=script&lang=js&"
export * from "./ProfileDataImage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDataImage.vue?vue&type=style&index=0&id=2d3e69ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3e69ed",
  null
  
)

export default component.exports